import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './Image.css';
import { VideoIcon } from '../../../common/icons';
import { preloadImage } from '../../constants';
import { NoImage } from '../NoImage';

enum LoadingStatus {
  loading = 0,
  loaded = 1,
  error = 2,
  waiting = 3,
}

export interface IImageSimpleState {
  status: LoadingStatus;
}

export interface IImageProps {
  alt?: string;
  src: string;
  isVideo?: boolean;
  index?: number;
  isLazyLoad?: boolean;
}

export class Image extends React.Component<IImageProps, IImageSimpleState> {
  public constructor(props: IImageProps) {
    super(props);
    this.state = { status: LoadingStatus.loading };
  }

  public render() {
    const { alt = '', src, isVideo, isLazyLoad } = this.props;

    const isLoading = this.state.status === LoadingStatus.loading;
    const isError = this.state.status === LoadingStatus.error;

    return (
      <div {...mergeStyles(styles['image'], styles['image-error'], styles['image-loading'])}>
        {!isError && (
          <div className={styles['image-container']}>
            <img
              {...mergeStyles(isLazyLoad && 'tns-lazy-img')}
              alt={alt}
              src={isLazyLoad ? preloadImage : src}
              data-src={src}
              onLoad={this.onLoad}
              width="640"
            />
            {isVideo && (
              <div className={styles['video_play']}>
                <VideoIcon />
              </div>
            )}
          </div>
        )}
        {!isLoading && isError && <NoImage />}
      </div>
    );
  }

  public onLoad = () => {
    this.setState({ status: LoadingStatus.loaded });
  };

  public onError = () => {
    this.setState({ status: LoadingStatus.error });
  };
}
